import type { Network } from "../types";

export const email: Network = {
  name: "Email",
  shareUrl: "mailto:?body=[u]",
  args: {
    title: "&subject=[t]",
  },
  icon: "/media/images/social-share-email.png",
  color: "#7e7e7e",
};
